var render, staticRenderFns
import script from "./DoughnutExample.vue?vue&type=script&lang=js&"
export * from "./DoughnutExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DoughnutExample.vue"
export default component.exports